document.addEventListener('DOMContentLoaded', function() {
  const builder = document.querySelector('[data-soup-bundle-builder]');
  if (!builder) return;

  const validQuantities = builder.dataset.validQuantities
    .split(',')
    .filter(Boolean)
    .map(q => parseInt(q, 10))
    .sort((a, b) => a - b);

  const minQuantity = validQuantities[0];
  const maxQuantity = validQuantities[validQuantities.length - 1];

  // Selected flavor counts, keyed by product id
  let selectedItems = {};

  // The pack size the shopper explicitly clicked (null = none clicked yet,
  // falls back to auto-detecting whichever tier the totals happen to hit)
  let selectedTarget = null;

  const slotDisplay = document.querySelector('[data-slots]');
  const tierElements = document.querySelectorAll('[data-tier]');
  const cartBtn = document.querySelector('[data-cta]');
  const cartBtnText = document.querySelector('[data-cta-text]');
  const priceFinal = document.querySelector('[data-price-final]');

  // Tiers come from THIS product's own priced variants -- not per-soup math
  const tierData = {};
  tierElements.forEach(el => {
    const qty = parseInt(el.dataset.tierQuantity, 10);
    tierData[qty] = {
      quantity: qty,
      variantId: el.dataset.tierVariantId,
      price: parseFloat(el.dataset.tierPrice) || 0,
      priceFormatted: el.dataset.tierPriceFormatted,
      name: el.dataset.tierName,
      element: el
    };
  });

  // ==========================================================================
  // TIER SELECTION (click a pack size to target it)
  // ==========================================================================

  tierElements.forEach(el => {
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');

    const selectTier = () => {
      const qty = parseInt(el.dataset.tierQuantity, 10);
      selectedTarget = (selectedTarget === qty) ? null : qty;
      updateUI();
    };

    el.addEventListener('click', selectTier);
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectTier();
      }
    });
  });

  // ==========================================================================
  // FLAVOR CARDS (quantity pickers only -- no per-item price)
  // ==========================================================================

  const bundleCards = document.querySelectorAll('.bundle-card');
  bundleCards.forEach((card) => {
    const productId = card.dataset.productId;
    const productTitle = card.dataset.productTitle;
    const qtyDisplay = card.querySelector('[data-qty]');
    const decrementBtn = card.querySelector('[data-decrement]');
    const incrementBtn = card.querySelector('[data-increment]');

    if (!selectedItems[productId]) {
      selectedItems[productId] = { title: productTitle, quantity: 0 };
    }

    decrementBtn.addEventListener('click', () => {
      if (selectedItems[productId].quantity > 0) {
        selectedItems[productId].quantity--;
        qtyDisplay.textContent = selectedItems[productId].quantity;
        updateUI();
      }
    });

    incrementBtn.addEventListener('click', () => {
      const cap = selectedTarget || maxQuantity;
      if (getTotalItems() >= cap) return;
      selectedItems[productId].quantity++;
      qtyDisplay.textContent = selectedItems[productId].quantity;
      updateUI();
    });
  });

  // ==========================================================================
  // NUTRITION MODAL
  // ==========================================================================

  document.querySelectorAll('[data-nutrition-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const card = this.closest('.bundle-card');
      const productId = card.dataset.productId;
      const modal = document.querySelector(`[data-nutrition-modal][data-product-id="${productId}"]`);
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-nutrition-close]').forEach((closeBtn) => {
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      const modal = this.closest('[data-nutrition-modal]');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.bundle-nutrition-modal.active').forEach(modal => {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
  });

  // ==========================================================================
  // HELPERS
  // ==========================================================================

  function getTotalItems() {
    let total = 0;
    for (let id in selectedItems) total += selectedItems[id].quantity;
    return total;
  }

  function getExactTier(totalItems) {
    return tierData[totalItems] || null;
  }

  // ==========================================================================
  // UI UPDATE
  // ==========================================================================

  function updateUI() {
    const totalItems = getTotalItems();

    const selectedList = [];
    for (let id in selectedItems) {
      const item = selectedItems[id];
      if (item.quantity > 0) selectedList.push(`${item.quantity}× ${item.title}`);
    }
    slotDisplay.innerHTML = selectedList.map(t => `<span class="bundle-builder__slot-item">${t}</span>`).join('');

    tierElements.forEach(el => {
      const tierQty = parseInt(el.dataset.tierQuantity, 10);
      el.classList.toggle('bundle-tier--reached', totalItems === tierQty);
      el.classList.toggle('bundle-tier--selected', selectedTarget === tierQty);
    });

    const exactTier = getExactTier(totalItems);

    // Price ALWAYS reflects the fixed pack variant price, never a per-soup sum
    if (priceFinal) {
      if (exactTier) {
        priceFinal.textContent = exactTier.priceFormatted;
      } else if (selectedTarget && tierData[selectedTarget]) {
        priceFinal.textContent = tierData[selectedTarget].priceFormatted;
      } else {
        priceFinal.textContent = tierData[minQuantity] ? tierData[minQuantity].priceFormatted : '';
      }
    }

    if (selectedTarget) {
      // Shopper clicked a pack size -- guide them toward that exact target
      const target = tierData[selectedTarget];
      if (totalItems === selectedTarget) {
        cartBtn.disabled = false;
        cartBtnText.textContent = `Add ${target.name} to Cart — ${target.priceFormatted}`;
        cartBtn.onclick = (e) => {
          e.preventDefault();
          addToCart(selectedItems, target);
        };
      } else if (totalItems < selectedTarget) {
        cartBtn.disabled = true;
        cartBtnText.textContent = `Add ${selectedTarget - totalItems} more to reach ${target.name}`;
      } else {
        cartBtn.disabled = true;
        const over = totalItems - selectedTarget;
        cartBtnText.textContent = `Remove ${over} item${over > 1 ? 's' : ''} to fit ${target.name}`;
      }
      return;
    }

    // No pack size clicked yet -- fall back to auto-detecting an exact match
    if (totalItems === 0) {
      cartBtn.disabled = true;
      cartBtnText.textContent = `Select a pack size`;
    } else if (exactTier) {
      cartBtn.disabled = false;
      cartBtnText.textContent = `Add ${exactTier.name} to Cart — ${exactTier.priceFormatted}`;
      cartBtn.onclick = (e) => {
        e.preventDefault();
        addToCart(selectedItems, exactTier);
      };
    } else if (totalItems < minQuantity) {
      cartBtn.disabled = true;
      cartBtnText.textContent = `Add ${minQuantity - totalItems} more to reach ${minQuantity}-Pack`;
    } else if (totalItems > maxQuantity) {
      cartBtn.disabled = true;
      const over = totalItems - maxQuantity;
      cartBtnText.textContent = `Remove ${over} item${over > 1 ? 's' : ''}`;
    } else {
      cartBtn.disabled = true;
      const nextTier = validQuantities.find(q => q > totalItems);
      if (nextTier) {
        cartBtnText.textContent = `Add ${nextTier - totalItems} more to reach ${nextTier}-Pack`;
      } else {
        cartBtnText.textContent = `Adjust to ${validQuantities.join(' or ')} items`;
      }
    }
  }

  // ==========================================================================
  // ADD TO CART
  // Always adds ONE unit of the matched pack variant (its own fixed price),
  // with the flavor mix attached as line item properties -- never priced
  // per soup, so the charge always matches the pack's real price.
  // ==========================================================================

  function addToCart(items, tier) {
    const properties = { '_pack_size': tier.name };
    for (let id in items) {
      const item = items[id];
      if (item.quantity > 0) {
        properties[item.title] = String(item.quantity);
      }
    }

    cartBtn.disabled = true;
    cartBtnText.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: tier.variantId, quantity: 1, properties: properties }]
      })
    })
    .then(r => r.json())
    .then(() => { window.location.href = '/cart'; })
    .catch(err => {
      console.error('Error adding to cart:', err);
      alert('There was an error adding to your cart. Please try again.');
      cartBtn.disabled = false;
      cartBtnText.textContent = `Add ${tier.name} to Cart — ${tier.priceFormatted}`;
    });
  }

  updateUI();
});